module.exports = __webpack_public_path__ + "static/media/coin.ce312799.svg";